import { useLayoutEffect } from 'react';
import { useDependencies } from '@servicetitan/react-ioc';
import { FinancingApi } from '@servicetitan/financing-api-client';
import { PrequalsApi } from '@servicetitan/financing-api-client/src/prequals-api';
import { FintechDataApi } from '@servicetitan/financing-api-client/src/fintech-data-api';
import {
    resolveApplicationAttribution,
    setFinancingAttribution,
} from '@servicetitan/financing-utils-shared';
import { SetupDataStore } from '../stores/setupDataStore';
import { useServiceFinancePrequalsEnabled } from './useServiceFinancePrequalsEnabled';

export const useSyncProviderToFinancingApi = () => {
    const { setupData } = SetupDataStore.useStore();
    const [financingApi] = useDependencies(FinancingApi);
    const [prequalsApi] = useDependencies(PrequalsApi);
    const [fintechDataApi] = useDependencies(FintechDataApi);
    const serviceFinancePrequalsEnabled = useServiceFinancePrequalsEnabled();

    // Use useLayoutEffect to ensure this runs synchronously before any child effects.
    // Clear back to Unspecified when provider is empty so a leftover loan provider
    // cannot pin X-ST-FIN-Provider on the next New Application.
    useLayoutEffect(() => {
        const provider = setupData?.provider;
        const headerValue = provider && provider.length > 0 ? provider : 'Unspecified';
        financingApi.setFinancingProvider(headerValue);
        prequalsApi.setFinancingProvider(headerValue);
        fintechDataApi?.setFinancingProvider(headerValue);
        setFinancingAttribution({
            provider: headerValue,
            ...resolveApplicationAttribution(setupData, {
                treatAsSoftPrequal: serviceFinancePrequalsEnabled,
            }),
        });
    }, [setupData, serviceFinancePrequalsEnabled, financingApi, prequalsApi, fintechDataApi]);
};
